export const number = (value) => value == null ? "—" : Number(value).toLocaleString("sv-SE");
export const dateTime = (value) => {
  if (!value || !Number.isFinite(Date.parse(value))) return "—";
  return new Date(value).toLocaleString("sv-SE", { dateStyle: "medium", timeStyle: "short" });
};
export const duration = (seconds) => {
  if (seconds == null) return "—";
  if (seconds < 60) return `${seconds} sek`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)} min ${seconds % 60} sek`;
  return `${Math.floor(seconds / 3600)} tim ${Math.floor(seconds % 3600 / 60)} min`;
};
export const statusInfo = (status) => ({
  queued: ["Startar", "amber"], running: ["Importerar", "amber"], staging: ["Importerar", "amber"],
  completed: ["Klar", "blue"], validated: ["Klar", "blue"],
  published: ["Publicerad", "green"], autopublished: ["Publicerad", "green"],
  superseded: ["Tidigare katalog", "gray"], unchanged_not_published: ["Oförändrad", "gray"],
  blocked_suspicious: ["Blockerad", "amber"], failed: ["Misslyckad", "red"],
  import_failed: ["Misslyckad", "red"], import_not_validated: ["Misslyckad", "red"],
  publish_failed: ["Misslyckad", "red"], no_source: ["Misslyckad", "red"],
  interrupted: ["Avbruten", "red"], skipped_import_in_progress: ["Hoppades över", "gray"],
  validated_awaiting_manual_publish: ["Klar – inte publicerad", "blue"],
}[status] || ["Okänd status", "gray"]);

const reasons = {
  zero_products: "Inga produkter hittades.",
  product_count_drop: "Ovanligt många produkter saknas jämfört med den aktiva katalogen.",
  high_reject_ratio: "För många sidor kunde inte läsas in eller tolkas.",
  structural_removal: "En stor del av katalogens tidigare sidor saknas.",
  mass_hash_change: "Ovanligt många katalogposter har ändrats samtidigt.",
};
export const refreshReason = (run) => {
  const known = (run.assessment?.reasons || []).map((r) => reasons[String(r).split("(")[0]] || "En säkerhetskontroll stoppade publiceringen.");
  if (known.length) return [...new Set(known)].join(" ");
  if (run.worker_state === "interrupted") return "Körningen har inte längre ett giltigt importlås.";
  return {
    skipped_import_in_progress: "En annan import pågick redan för källan.",
    import_failed: "Importen kunde inte slutföras.", import_not_validated: "Importen kunde inte valideras.",
    publish_failed: "Den nya katalogen kunde inte publiceras.", no_source: "Datakällan kunde inte hittas.",
    validated_awaiting_manual_publish: "Den första publiceringen väntar på godkännande.",
  }[run.status] || "";
};